import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/features/shell/Shell.tsx");
